import Vue from 'vue'
import Router from "vue-router"

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

const router = new Router({
	mode: 'history',
	// 路由切换后回到顶部
	scrollBehavior: () => ({ y: 0 }),
	routes: [{
		path: "/",
		component: (resolve) => require(['@/view/main.vue'],resolve),
		children: [{
			path: '/',
			component: (resolve) => require(['@/view/Basics/brand.vue'],resolve),
		},{
			path: '/User/edit.html',
			component: (resolve) => require(['@/view/User/edit.vue'],resolve),
		},{
			path: '/Basics/Gold.html',
			component: (resolve) => require(['@/view/Basics/Gold.vue'],resolve),
		},{
			path: '/Basics/GoldEdit.html',
			component: (resolve) => require(['@/view/Basics/GoldEdit.vue'],resolve),
		},{
			path: '/Basics/brand.html',
			component: (resolve) => require(['@/view/Basics/brand.vue'],resolve),
		},{
			path: '/Basics/brandApply.html',
			component: (resolve) => require(['@/view/Basics/brandApply.vue'],resolve),
		},{
			path: '/Basics/brandEdit.html',
			component: (resolve) => require(['@/view/Basics/brandEdit.vue'],resolve),
		},{
			path: '/Sms/index.html',
			component: (resolve) => require(['@/view/Sms/index.vue'],resolve),
		},{
			path: '/Pay/index.html',
			component: (resolve) => require(['@/view/Pay/index.vue'],resolve),
		},{
			path: '/Storage/index.html',
			component: (resolve) => require(['@/view/Storage/index.vue'],resolve),
		},{
			path: '/Merchant/index.html',
			component: (resolve) => require(['@/view/Merchant/index.vue'],resolve),
		},{
			path: '/Merchant/edit.html',
			component: (resolve) => require(['@/view/Merchant/edit.vue'],resolve),
		},{
			path: '/Channel/index.html',
			component: (resolve) => require(['@/view/Channel/index.vue'],resolve),
		},{
			path: '/Channel/edit.html',
			component: (resolve) => require(['@/view/Channel/edit.vue'],resolve),
		},{
			path: '/Channel/stat.html',
			component: (resolve) => require(['@/view/Channel/stat.vue'],resolve),
		},{
			path: '/Channel/bill.html',
			component: (resolve) => require(['@/view/Channel/bill.vue'],resolve),
		},{
			path: '/Credit/index.html',
			component: (resolve) => require(['@/view/Credit/index.vue'], resolve),
		},{
			path: '/Shop/index.html',
			component: (resolve) => require(['@/view/Shop/index.vue'],resolve),
		},{
			path: '/Shop/edit.html',
			component: (resolve) => require(['@/view/Shop/edit.vue'],resolve),
		},{
			path: '/Supplier/index.html',
			component: (resolve) => require(['@/view/Supplier/index.vue'],resolve),
		},{
			path: '/Supplier/edit.html',
			component: (resolve) => require(['@/view/Supplier/edit.vue'],resolve),
		},{
			path: '/Supplier/view.html',
			component: (resolve) => require(['@/view/Supplier/view.vue'],resolve),
		},{
			path: '/Goods/index.html',
			component: (resolve) => require(['@/view/Goods/index.vue'],resolve),
		},{
			path: '/Goods/edit.html',
			component: (resolve) => require(['@/view/Goods/edit.vue'],resolve),
		},{
			path: '/Goods/mrchantIndex.html',
			component: (resolve) => require(['@/view/Goods/mrchantIndex.vue'],resolve),
		},{
			path: '/GoodsAudit/index.html',
			component: (resolve) => require(['@/view/GoodsAudit/index.vue'],resolve),
		},{
			path: '/GoodsAudit/edit.html',
			component: (resolve) => require(['@/view/GoodsAudit/edit.vue'],resolve),
		},{
			path: '/GoodsAudit/supplierGoods.html',
			component: (resolve) => require(['@/view/GoodsAudit/supplierGoods.vue'],resolve),
		},{
			path: '/Category/index.html',
			component: (resolve) => require(['@/view/Category/index.vue'],resolve),
		},{
			path: '/Category/edit.html',
			component: (resolve) => require(['@/view/Category/edit.vue'],resolve),
		},{
			path: '/Trade/index.html',
			component: (resolve) => require(['@/view/Trade/index.vue'],resolve),
		},{
			path: '/Trade/edit.html',
			component: (resolve) => require(['@/view/Trade/edit.vue'],resolve),
		},{
			path: '/TradeTemplate/index.html',
			component: (resolve) => require(['@/view/TradeTemplate/index.vue'],resolve),
		},{
			path: '/TradeTemplate/edit.html',
			component: (resolve) => require(['@/view/TradeTemplate/edit.vue'],resolve),
		},{
			path: '/TradeTemplateData/index.html',
			component: (resolve) => require(['@/view/TradeTemplateData/index.vue'],resolve),
		},{
			path: '/TradeTemplateData/edit.html',
			component: (resolve) => require(['@/view/TradeTemplateData/edit.vue'],resolve),
		},{
			path: '/Member/MemberList.html',
			component: (resolve) => require(['@/view/Member/MemberList.vue'],resolve),
		},{
			path: '/Member/MemberListEdit.html',
			component: (resolve) => require(['@/view/Member/MemberListEdit.vue'],resolve),
		},{
			path: '/Member/jifen.html',
			component: (resolve) => require(['@/view/Member/jifen.vue'],resolve),
		},{
			path: '/Member/jifenlog.html',
			component: (resolve) => require(['@/view/Member/jifenlog.vue'],resolve),
		},{
			path: '/Indent/index.html',
			component: (resolve) => require(['@/view/Indent/index.vue'],resolve),
		},{
			path: '/Indent/list.html',
			component: (resolve) => require(['@/view/Indent/list.vue'],resolve),
		},{
			path: '/Indent/complete.html',
			component: (resolve) => require(['@/view/Indent/complete.vue'],resolve),
		},{
			path: '/Indent/unfinished.html',
			component: (resolve) => require(['@/view/Indent/unfinished.vue'],resolve),
		},{
			path: '/Refund/index.html',
			component: (resolve) => require(['@/view/refund/index.vue'],resolve),
		},{
			path: '/Refund/edit.html',
			component: (resolve) => require(['@/view/refund/edit.vue'],resolve),
		},{
			path: '/Repertory/index.html',
			component: (resolve) => require(['@/view/Repertory/index.vue'],resolve),
		},{
			path: '/Repertory/in.html',
			component: (resolve) => require(['@/view/Repertory/in.vue'],resolve),
		},{
			path: '/Repertory/out.html',
			component: (resolve) => require(['@/view/Repertory/out.vue'],resolve),
		},{
			path: '/Repertory/goodsIn.html',
			component: (resolve) => require(['@/view/Repertory/goodsIn.vue'],resolve),
		},{
			path: '/Repertory/goodsOut.html',
			component: (resolve) => require(['@/view/Repertory/goodsOut.vue'],resolve),
		},{
			path: '/Repertory/detail.html',
			component: (resolve) => require(['@/view/Repertory/detail.vue'],resolve),
		},{
			path: '/Logistics/LogisticsListEdit.html',
			component: (resolve) => require(['@/view/Logistics/LogisticsListEdit.vue'],resolve),
		},{
			path: '/Logistics/LogisticsList.html',
			component: (resolve) => require(['@/view/Logistics/LogisticsList.vue'],resolve),
		},{
			path: '/Logistics/pickUp.html',
			component: (resolve) => require(['@/view/Logistics/pickUp.vue'],resolve),
		},{
			path: '/Logistics/pickUpEdit.html',
			component: (resolve) => require(['@/view/Logistics/pickUpEdit.vue'],resolve),
		},{
			path: '/Settings/role.html',
			component: (resolve) => require(['@/view/Settings/role.vue'],resolve),
		},{
			path: '/Settings/roleEdit.html',
			component: (resolve) => require(['@/view/Settings/roleEdit.vue'],resolve),
		},{
			path: '/Settings/index.html',
			component: (resolve) => require(['@/view/Settings/index.vue'],resolve),
		},{
			path: '/Settings/edit.html',
			component: (resolve) => require(['@/view/Settings/edit.vue'],resolve),
		},{
			path: '/Settings/assign.html',
			component: (resolve) => require(['@/view/Settings/assign.vue'],resolve),
		}, {
			path: '/Settings/expressapi.html',
			component: (resolve) => require(['@/view/Settings/expressapi.vue'], resolve),
		}, {
			path: '/Finance/statement.html',
			component: (resolve) => require(['@/view/Finance/statement.vue'],resolve),
		},{
			path: '/Finance/index.html',
			component: (resolve) => require(['@/view/Finance/index.vue'],resolve),
		},{
			path: '/Finance/audioStatement.html',
			component: (resolve) => require(['@/view/Finance/audioStatement.vue'],resolve),
		},{
			path: '/Finance/endStatement.html',
			component: (resolve) => require(['@/view/Finance/endStatement.vue'],resolve),
		},{
			path: '/Finance/AccountType.html',
			component: (resolve) => require(['@/view/Finance/AccountType.vue'],resolve),
		},{
			path: '/Finance/AccountTypeEdit.html',
			component: (resolve) => require(['@/view/Finance/AccountTypeEdit.vue'],resolve),
		},{
			path: '/Finance/water.html',
			component: (resolve) => require(['@/view/Finance/water.vue'],resolve),
		},{
			path: '/Finance/generate.html',
			component: (resolve) => require(['@/view/Finance/generate.vue'],resolve),
		},{
			path: '/Finance/check.html',
			component: (resolve) => require(['@/view/Finance/check.vue'],resolve),
		},{
			path: '/Finance/settlement.html',
			component: (resolve) => require(['@/view/Finance/settlement.vue'],resolve),
		},{
			path: '/Finance/detail.html',
			component: (resolve) => require(['@/view/Finance/detail.vue'],resolve),
		}]
	},{
		path: "/login.html",
		component: (resolve) => require(['@/view/login.vue'],resolve),
	}]
})

const whiteList = ['/login.html']
// 路由变化之后触发
router.beforeEach((to, from, next)=>{
	let token = localStorage.token
	// 大写转小写
	let path = to.path.toLowerCase()
	// to.path 获取点击的那页的路由
	// console.log(to.path);
	// 防止已经登录的用户，再次点击的时候 还需要登录
	// 伪造token是可以进来，但是进来之后接口用不了
	if(token && path === '/login.html'){
		next({path:'/'})
	//	如果没有token 且不在登录页面则跳转到登录页面
	}else if(!token && whiteList.indexOf(path) === -1){
		next({
			path:"/login.html",
			query: {
		// to.fullPath 指向路由
				redirect: to.fullPath
			}
		})
	}else{
		next()
	}
})

export default router
